import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInjector, UnauthorizedInterceptorService } from '@coin/shared/auth/data-access';
// Temporary EXR mock backend. TODO: Remove together with season-mgmt/mocks/ once the EXR backend exists.
import { ExrMockInterceptor } from '../season-mgmt/mocks/exr-mock.interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: TokenInjector, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ExrMockInterceptor, multi: true }
];
